module.exports = __webpack_public_path__ + "static/media/Group3633.a109714a.svg";